/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shared_Download_XlsxInputs */

const en_shared_download_xlsx = /** @type {(inputs: Shared_Download_XlsxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download XLSX`)
};

const nl_shared_download_xlsx = /** @type {(inputs: Shared_Download_XlsxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XLSX downloaden`)
};

/** @type {(inputs: Shared_Download_XlsxInputs) => LocalizedString} */
const de_shared_download_xlsx = en_shared_download_xlsx;

/** @type {(inputs: Shared_Download_XlsxInputs) => LocalizedString} */
const es_shared_download_xlsx = en_shared_download_xlsx;

/** @type {(inputs: Shared_Download_XlsxInputs) => LocalizedString} */
const fr_shared_download_xlsx = en_shared_download_xlsx;

/** @type {(inputs: Shared_Download_XlsxInputs) => LocalizedString} */
const it_shared_download_xlsx = en_shared_download_xlsx;

/** @type {(inputs: Shared_Download_XlsxInputs) => LocalizedString} */
const pt_br2_shared_download_xlsx = en_shared_download_xlsx;

/** @type {(inputs: Shared_Download_XlsxInputs) => LocalizedString} */
const pl_shared_download_xlsx = en_shared_download_xlsx;

/** @type {(inputs: Shared_Download_XlsxInputs) => LocalizedString} */
const hu_shared_download_xlsx = en_shared_download_xlsx;

/** @type {(inputs: Shared_Download_XlsxInputs) => LocalizedString} */
const ro_shared_download_xlsx = en_shared_download_xlsx;

/**
* | output |
* | --- |
* | "Download XLSX" |
*
* @param {Shared_Download_XlsxInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const shared_download_xlsx = /** @type {((inputs?: Shared_Download_XlsxInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shared_Download_XlsxInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shared_download_xlsx(inputs)
	if (locale === "de") return de_shared_download_xlsx(inputs)
	if (locale === "es") return es_shared_download_xlsx(inputs)
	if (locale === "fr") return fr_shared_download_xlsx(inputs)
	if (locale === "nl") return nl_shared_download_xlsx(inputs)
	if (locale === "it") return it_shared_download_xlsx(inputs)
	if (locale === "pt-BR") return pt_br2_shared_download_xlsx(inputs)
	if (locale === "pl") return pl_shared_download_xlsx(inputs)
	if (locale === "hu") return hu_shared_download_xlsx(inputs)
	return ro_shared_download_xlsx(inputs)
});
export { shared_download_xlsx as "shared.download_xlsx" }